export const VAT_CH = 0.081;

export const TOTAL_OVERWRITE_TEMPLATE_START_FROM_HOTELID = '68c2f8c90c0aced1a901ec03';

export const WL_STATUS = {
  INITIAL: 'INITIAL',
  DEMO: 'DEMO',
  ACCEPTED: 'ACCEPTED',
  INVOICE: 'INVOICE CREATED', // ACCEPTED but with once downloaded invoice
  PAID: 'PAID',
};

export const WL_ACCEPT_STATUS = {
  ACCEPT_REQUIRED: 1,
  ACCEPTED: 2,
};

export const WL_AREA = {
  BR: '5e987c729ad890771a2ff5fa',
  CH: '58199654b9f86b37c18b5981',
};

export const WL_TYPE = {
  ADVANCED: 'ADVANCED',
  ADVANCEDB: 'ADVANCEDB',
  ADVANCEDC: 'ADVANCEDC',
  PROFESSIONAL: 'PROFESSIONAL',
  BRONZE: 'BRONZE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  PLATINUM: 'PLATINUM',
};

export const WL_TYPES = [WL_TYPE.BRONZE, WL_TYPE.SILVER, WL_TYPE.GOLD, WL_TYPE.PLATINUM];

export const WL_PRICES = {
  [WL_TYPE.ADVANCED]: 60,
  [WL_TYPE.ADVANCEDB]: 85,
  [WL_TYPE.ADVANCEDC]: 110,
  [WL_TYPE.PROFESSIONAL]: 300,
  [WL_TYPE.BRONZE]: 29,
  [WL_TYPE.SILVER]: 49,
  [WL_TYPE.GOLD]: 69,
  [WL_TYPE.PLATINUM]: 99,
};

export const WL_PRICES_BR = {
  [WL_TYPE.ADVANCED]: 370,
  [WL_TYPE.PROFESSIONAL]: 1550,
};
